import type { Quality } from "./types";

// Mirrors the preprocess-images lambda's `{base}_{quality}_{i}_{j}.{ext}`.
export function buildTileUrl(
  baseUrl: string,
  extension: string,
  quality: Quality,
  i: number,
  j: number,
): string {
  const suffix = `_${quality}_${i}_${j}`;
  return extension ? `${baseUrl}${suffix}.${extension}` : `${baseUrl}${suffix}`;
}
